import { jsx as _jsx } from "react/jsx-runtime";
import { reportErrorToBugsnag } from "@air/utils-error";
import noop from "lodash/noop";
import { createContext, memo, useContext, useMemo, useState } from "react";
import { SEARCH_INITIAL_HEADER_HEIGHT } from "~/constants/WorkspaceSpacing";
import { isDevOrTestStage } from "~/swr-hooks/utils";
const defaultValue = {
    searchHeaderHeight: 0,
    setSearchHeaderHeight: noop
};
export const SearchHeaderHeightContext = /*#__PURE__*/ createContext(defaultValue);
export const SearchHeaderHeightProvider = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const [searchHeaderHeight, setSearchHeaderHeight] = useState(SEARCH_INITIAL_HEADER_HEIGHT);
    const value = useMemo(()=>({
            searchHeaderHeight,
            setSearchHeaderHeight
        }), [
        searchHeaderHeight
    ]);
    return /*#__PURE__*/ _jsx(SearchHeaderHeightContext.Provider, {
        value: value,
        children: children
    });
});
SearchHeaderHeightProvider.displayName = "SearchHeaderHeightProvider";
export const useSearchHeaderHeightContext = ()=>{
    const context = useContext(SearchHeaderHeightContext);
    if (context === defaultValue) {
        const error = "SearchHeaderHeightContext used outside of SearchHeaderHeightProvider";
        if (isDevOrTestStage()) {
            throw error;
        } else {
            reportErrorToBugsnag({
                error,
                context: error
            });
        }
    }
    return context;
};
